var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { injectable } from 'inversify';
import { BaseManagementService } from '../base-management-service';
import toBase64 from '@/utils/base64';
import * as format from 'date-fns/format';
var ContractManagementService = /** @class */ (function (_super) {
    __extends(ContractManagementService, _super);
    function ContractManagementService() {
        return _super.call(this, '/api/v1/management/contract') || this;
    }
    ContractManagementService.prototype.getValidationRules = function () {
        return {
            // step 1
            contractType: {
                required: true,
                max: 2,
            },
            contractDescription: {
                required: true,
                max: 50,
            },
            supplierId: {
                required: true,
                max: 6,
            },
            materialGroupId: {
                required: true,
                max: 1,
            },
            supplierContractId: {
                max: 10,
            },
            indexMarket: {
                required: true,
                max: 30,
            },
            startDate: {
                required: true,
                date_format: 'MM/dd/yyyy',
                // before: 'endDate',
            },
            endDate: {
                required: true,
                date_format: 'MM/dd/yyyy',
                // after: 'startDate',
            },
            revisedEndDate: {
                date_format: 'MM/dd/yyyy',
            },
            actualEndDate: {
                date_format: 'MM/dd/yyyy',
            },
            underLiftPenalty: {
                decimal: 3,
            },
            overLiftPenalty: {
                decimal: 3,
            },
            lowerTolerance: {
                decimal: 2,
            },
            upperTolerance: {
                decimal: 2,
            },
            mostRecentBidDate: {
                date_format: 'MM/dd/yyyy',
            },
            contactFirstName: {
                max: 50,
            },
            contactLastName: {
                max: 50,
            },
            contactPhone: {
                max: 30,
            },
            contactCellPhone: {
                max: 30,
            },
            contactEmail: {
                max: 100,
                email: true,
            },
            contactHelpdeskPhone: {
                max: 30,
            },
            website: {
                max: 100,
                url: true,
            },
            notes: {
                max: 500,
            },
            status: {
                required: true,
            },
            // step 2
            defaultPricingFormula_StartDate: {
                required: true,
                date_format: 'MM/dd/yyyy',
                // before: 'defaultPricingFormula_EndDate',
            },
            defaultPricingFormula_EndDate: {
                required: true,
                date_format: 'MM/dd/yyyy',
                // after: 'defaultPricingFormula_StartDate',
            },
            defaultPricingFormula_Formula: {
                required: true,
                max: 500,
            },
            // step 3
            defaultAllocationPeriod_Period: {
                required: true,
            },
            defaultAllocationPeriod_StartDate: {
                required: true,
                date_format: 'MM/dd/yyyy',
                // before: 'defaultAllocationPeriod_EndDate',
            },
            defaultAllocationPeriod_EndDate: {
                required: true,
                date_format: 'MM/dd/yyyy',
                // after: 'defaultAllocationPeriod_StartDate',
            },
            defaultAllocationPeriod_ContractVolume: {
                required: true,
                numeric: true,
            },
            // step 4
            vendorMaterial_VendorId: {
                required: true,
            },
            vendorMaterial_MaterialId: {
                required: true,
            },
            vendorMaterialPricingFormula_StartDate: {
                required: true,
                // before: 'vendorMaterialPricingFormula_EndDate',
            },
            vendorMaterialPricingFormula_EndDate: {
                required: true,
                // after: 'vendorMaterialPricingFormula_StartDate',
            },
            vendorMaterialPricingFormula_Formula: {
                required: true,
                max: 500,
            },
        };
    };
    ContractManagementService.prototype.getContractFileValidationRules = function () {
        return {
            contractFileName: {
                required: true,
            },
        };
    };
    ContractManagementService.prototype.getDefault = function () {
        return {
            contractId: 0,
            contractDescription: '',
            contractType: '',
            contractTypeDescription: '',
            supplierId: '',
            supplierName: '',
            materialGroupId: '',
            materialGroupDescription: '',
            contractFile: {},
            supplierContractId: '',
            indexMarket: '',
            startDate: format(new Date(), 'YYYY-MM-DD'),
            endDate: null,
            revisedEndDate: null,
            actualEndDate: null,
            isEvergreen: false,
            isCancellable: false,
            daysNotice: null,
            underLiftPenalty: null,
            overLiftPenalty: null,
            lowerTolerance: null,
            upperTolerance: null,
            defaultAllocationPeriod: '',
            defaultAllocationStartDate: null,
            defaultAllocationEndDate: null,
            contractVolume: null,
            rinsPerGallon: null,
            taxCreditPercent: null,
            mostRecentBidDate: null,
            mostRecentBiddersCount: null,
            paymentTerms: '',
            cancellationReason: '',
            website: '',
            notes: '',
            status: 'P',
            createdId: '',
            createdDate: null,
            modId: '',
            modDate: null,
            cancelledId: '',
            cancelledDate: null,
            completedId: '',
            completedDate: null,
            isDeleted: false,
            contractFiles: [],
            contacts: [
                {
                    contactId: '',
                    contractId: 0,
                    contactType: 'SALES REP',
                    firstName: '',
                    lastName: '',
                    officePhone: '',
                    cellPhone: '',
                    email: '',
                    notes: '',
                    createdId: '',
                    createdDate: null,
                    modId: '',
                    modDate: null,
                },
            ],
            defaultPricingFormulas: [],
            allocationPeriods: [],
            vendorMaterials: [],
        };
    };
    ContractManagementService.prototype.getDefaultDefaultPricingFormula = function () {
        return {
            contractDefaultPricingXrefId: '',
            contractId: 0,
            startDate: null,
            endDate: null,
            formula: '',
            createdId: '',
            createdDate: null,
            modId: '',
            modDate: null,
        };
    };
    ContractManagementService.prototype.getDefaultAdditionalAllocationPeriod = function () {
        return {
            allocationId: '',
            contractId: 0,
            period: '',
            weekStartDay: '',
            createdId: '',
            createdDate: null,
            modId: '',
            modDate: null,
        };
    };
    ContractManagementService.prototype.getDefaultVendorMaterial = function () {
        return {
            contractVendorMaterialXrefId: '',
            contractId: 0,
            vendorId: '',
            vendorName: '',
            materialId: '',
            materialDescription: '',
            mayContain: false,
            unitOfMeasure: '',
            notes: '',
            createdId: '',
            createdDate: null,
            modId: '',
            modDate: null,
            pricingFormulas: [],
        };
    };
    ContractManagementService.prototype.getDefaultVendorMaterialPricingFormula = function () {
        return {
            contractVendorMaterialPricingXrefId: '',
            contractVendorMaterialXrefId: '',
            startDate: null,
            endDate: null,
            formula: '',
            createdId: '',
            createdDate: null,
            modId: '',
            modDate: null,
        };
    };
    ContractManagementService.prototype.getHours = function () {
        return [
            '00:00',
            '01:00',
            '02:00',
            '03:00',
            '04:00',
            '05:00',
            '06:00',
            '07:00',
            '08:00',
            '09:00',
            '10:00',
            '11:00',
            '12:00',
            '13:00',
            '14:00',
            '15:00',
            '16:00',
            '17:00',
            '18:00',
            '19:00',
            '20:00',
            '21:00',
            '22:00',
            '23:00',
        ];
    };
    ContractManagementService.prototype.createContract = function (item) {
        return __awaiter(this, void 0, Promise, function () {
            var endpoint, req, _a, response, responseMessage, error_1;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        endpoint = "/create";
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 6, , 7]);
                        _b = {
                            ContractType: item.contractType,
                            ContractDescription: item.contractDescription && item.contractDescription.length > 0 ? item.contractDescription : '',
                            SupplierId: item.supplierId,
                            MaterialGroupId: item.materialGroupId
                        };
                        if (!(item.contractFile && item.contractFile.size > 0)) return [3 /*break*/, 3];
                        return [4 /*yield*/, toBase64(item.contractFile)];
                    case 2:
                        _a = _c.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        _a = null;
                        _c.label = 4;
                    case 4:
                        req = (_b.ContractPdf64 = _a,
                            _b.ContractPdfFileName = item.contractFile && item.contractFile.name && item.contractFile.name.length > 0 ? item.contractFile.name : null,
                            _b.SupplierContractId = item.supplierContractId && item.supplierContractId.length > 0 ? item.supplierContractId : '',
                            _b.IndexMarket = item.indexMarket,
                            _b.StartDate = item.startDate,
                            _b.EndDate = item.endDate,
                            _b.RevisedEndDate = item.revisedEndDate,
                            _b.ActualEndDate = item.actualEndDate,
                            _b.IsEvergreen = item.isEvergreen,
                            _b.IsCancellable = item.isCancellable,
                            _b.DaysNotice = item.daysNotice,
                            _b.UnderLiftPenalty = item.underLiftPenalty,
                            _b.OverLiftPenalty = item.overLiftPenalty,
                            _b.LowerTolerance = item.lowerTolerance,
                            _b.UpperTolerance = item.upperTolerance,
                            _b.DefaultAllocationPeriod = item.defaultAllocationPeriod,
                            _b.DefaultAllocationStartDate = item.defaultAllocationStartDate,
                            _b.DefaultAllocationEndDate = item.defaultAllocationEndDate,
                            _b.ContractVolume = item.contractVolume,
                            _b.RinsPerGallon = item.rinsPerGallon,
                            _b.TaxCreditPercent = item.taxCreditPercent,
                            _b.MostRecentBidDate = item.mostRecentBidDate,
                            _b.MostRecentBiddersCount = item.mostRecentBiddersCount,
                            _b.PaymentTerms = item.paymentTerms,
                            _b.CancellationReason = item.cancellationReason,
                            _b.Website = item.website,
                            _b.Status = item.status,
                            _b.Notes = item.notes,
                            _b.Contacts = item.contacts,
                            _b.DefaultPricingFormulas = item.defaultPricingFormulas,
                            _b.AllocationPeriods = item.allocationPeriods,
                            _b.VendorMaterials = item.vendorMaterials,
                            _b);
                        return [4 /*yield*/, _super.prototype.post.call(this, endpoint, req)];
                    case 5:
                        response = _c.sent();
                        responseMessage = response.data;
                        if (response.status === 200) {
                            return [2 /*return*/, responseMessage];
                        }
                        else {
                            throw new Error("Unable to save contract");
                        }
                        return [3 /*break*/, 7];
                    case 6:
                        error_1 = _c.sent();
                        throw error_1;
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    ContractManagementService.prototype.updateContract = function (item) {
        return __awaiter(this, void 0, Promise, function () {
            var endpoint, req, _a, response, responseMessage, error_2;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        endpoint = "/update";
                        _b = {
                            ContractId: item.contractId,
                            ContractType: item.contractType,
                            ContractDescription: item.contractDescription && item.contractDescription.length > 0 ? item.contractDescription : '',
                            SupplierId: item.supplierId,
                            MaterialGroupId: item.materialGroupId
                        };
                        if (!(item.contractFile && item.contractFile.size > 0)) return [3 /*break*/, 2];
                        return [4 /*yield*/, toBase64(item.contractFile)];
                    case 1:
                        _a = _c.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        _a = null;
                        _c.label = 3;
                    case 3:
                        req = (_b.ContractPdf64 = _a,
                            _b.ContractPdfFileName = item.contractFile && item.contractFile.name && item.contractFile.name.length > 0 ? item.contractFile.name : null,
                            _b.SupplierContractId = item.supplierContractId && item.supplierContractId.length > 0 ? item.supplierContractId : '',
                            _b.IndexMarket = item.indexMarket,
                            _b.StartDate = item.startDate,
                            _b.EndDate = item.endDate,
                            _b.RevisedEndDate = item.revisedEndDate,
                            _b.ActualEndDate = item.actualEndDate,
                            _b.IsEvergreen = item.isEvergreen,
                            _b.IsCancellable = item.isCancellable,
                            _b.DaysNotice = item.daysNotice,
                            _b.UnderLiftPenalty = item.underLiftPenalty,
                            _b.OverLiftPenalty = item.overLiftPenalty,
                            _b.LowerTolerance = item.lowerTolerance,
                            _b.UpperTolerance = item.upperTolerance,
                            _b.DefaultAllocationPeriod = item.defaultAllocationPeriod,
                            _b.DefaultAllocationStartDate = item.defaultAllocationStartDate,
                            _b.DefaultAllocationEndDate = item.defaultAllocationEndDate,
                            _b.ContractVolume = item.contractVolume,
                            _b.RinsPerGallon = item.rinsPerGallon,
                            _b.TaxCreditPercent = item.taxCreditPercent,
                            _b.MostRecentBidDate = item.mostRecentBidDate,
                            _b.MostRecentBiddersCount = item.mostRecentBiddersCount,
                            _b.PaymentTerms = item.paymentTerms,
                            _b.CancellationReason = item.cancellationReason,
                            _b.Website = item.website,
                            _b.Status = item.status,
                            _b.Notes = item.notes,
                            _b.CreatedId = item.createdId,
                            _b.CreatedDate = item.createdDate,
                            _b.ModId = item.modId,
                            _b.ModDate = item.modDate,
                            _b.CancelledId = item.cancelledId,
                            _b.CancelledDate = item.cancelledDate,
                            _b.CompletedId = item.completedId,
                            _b.CompletedDate = item.completedDate,
                            _b.Contacts = item.contacts,
                            _b.DefaultPricingFormulas = item.defaultPricingFormulas,
                            _b.AllocationPeriods = item.allocationPeriods,
                            _b.VendorMaterials = item.vendorMaterials,
                            _b);
                        _c.label = 4;
                    case 4:
                        _c.trys.push([4, 6, , 7]);
                        return [4 /*yield*/, _super.prototype.post.call(this, endpoint, req)];
                    case 5:
                        response = _c.sent();
                        responseMessage = response.data;
                        if (response.status === 200) {
                            return [2 /*return*/, responseMessage];
                        }
                        else {
                            throw new Error("Unable to save contract");
                        }
                        return [3 /*break*/, 7];
                    case 6:
                        error_2 = _c.sent();
                        throw error_2;
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    ContractManagementService.prototype.deleteContract = function (contractId) {
        return __awaiter(this, void 0, Promise, function () {
            var endpoint, response, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        endpoint = '/delete';
                        return [4 /*yield*/, _super.prototype.post.call(this, endpoint, {
                                ContractId: contractId,
                            })];
                    case 1:
                        response = _a.sent();
                        if (response.status === 200) {
                            return [2 /*return*/, response.data];
                        }
                        else {
                            throw new Error('Unable to delete partial save');
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_3 = _a.sent();
                        console.error('Unable to delete partial save');
                        console.error(error_3);
                        throw error_3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ContractManagementService.prototype.getContractFile = function (id) {
        return __awaiter(this, void 0, Promise, function () {
            var endpoint, response, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        endpoint = 'getcontractfile';
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, _super.prototype.post.call(this, endpoint, {
                                ContractUploadXrefId: id,
                            }, {
                                responseType: 'arraybuffer',
                            })];
                    case 2:
                        response = _a.sent();
                        if (response.status === 200) {
                            return [2 /*return*/, response.data];
                        }
                        else {
                            throw new Error(response.data);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_4 = _a.sent();
                        console.error("Unable to get the contract file");
                        console.error(error_4);
                        throw error_4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ContractManagementService.prototype.doesVendorMaterialExist = function (vendorId, materialId) {
        return __awaiter(this, void 0, Promise, function () {
            var url, request, response, responseMessage, error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        url = 'doesVendorMaterialExist';
                        request = {
                            VendorId: vendorId,
                            MaterialId: materialId,
                        };
                        return [4 /*yield*/, _super.prototype.post.call(this, url, request)];
                    case 1:
                        response = _a.sent();
                        responseMessage = response.data;
                        if (response.status === 200 && responseMessage.success) {
                            return [2 /*return*/, responseMessage.data];
                        }
                        else {
                            throw new Error('Unable to check if this vendor/material is currently associated to an Active contract');
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_5 = _a.sent();
                        console.error('Unable to check if this vendor/material is currently associated to an Active contract');
                        console.error(error_5);
                        throw error_5;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ContractManagementService.prototype.doesVendorMaterialExistWithDates = function (vendorId, materialId, startDate, endDate) {
        return __awaiter(this, void 0, Promise, function () {
            var url, request, response, responseMessage, error_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        url = 'doesVendorMaterialExistWithDates';
                        request = {
                            VendorId: vendorId,
                            MaterialId: materialId,
                            StartDate: startDate,
                            EndDate: endDate,
                        };
                        return [4 /*yield*/, _super.prototype.post.call(this, url, request)];
                    case 1:
                        response = _a.sent();
                        responseMessage = response.data;
                        if (response.status === 200 && responseMessage.success) {
                            return [2 /*return*/, responseMessage.data];
                        }
                        else {
                            throw new Error('Unable to check if this vendor/material is currently associated to an Active contract');
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_6 = _a.sent();
                        console.error('Unable to check if this vendor/material is currently associated to an Active contract');
                        console.error(error_6);
                        throw error_6;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(ContractManagementService.prototype, "canEditContracts", {
        get: function () {
            return this.canEditPage('CONTRACTMGMT');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContractManagementService.prototype, "canViewContracts", {
        get: function () {
            return this.canViewPage('CONTRACTMGMT');
        },
        enumerable: false,
        configurable: true
    });
    ContractManagementService.prototype.generateExcelReport = function () {
        return __awaiter(this, void 0, Promise, function () {
            var endpoint, response, error_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        endpoint = 'getallexcel';
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, _super.prototype.post.call(this, endpoint, {}, {
                                responseType: 'arraybuffer',
                            })];
                    case 2:
                        response = _a.sent();
                        if (response.status === 200) {
                            return [2 /*return*/, response.data];
                        }
                        else {
                            throw new Error(response.data);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_7 = _a.sent();
                        console.error("Unable to generate report");
                        console.error(error_7);
                        throw error_7;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ContractManagementService.prototype.warnDeleteItemMaterial = function (item) {
        return __awaiter(this, void 0, Promise, function () {
            var endpoint, response, responseMessage, error_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        endpoint = '/searchcontractrefany';
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, _super.prototype.post.call(this, endpoint, { MaterialId: item.materialId })];
                    case 2:
                        response = _a.sent();
                        responseMessage = response.data;
                        if (response.status === 200 && responseMessage.success) {
                            return [2 /*return*/, responseMessage];
                        }
                        else {
                            throw new Error('Unable to check if material has contracts associated');
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_8 = _a.sent();
                        console.error("Unable to check if material has contracts associated");
                        console.error(error_8);
                        throw error_8;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ContractManagementService.prototype.warnDeleteItemVendor = function (item) {
        return __awaiter(this, void 0, Promise, function () {
            var endpoint, response, responseMessage, error_9;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        endpoint = '/searchcontractrefany';
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, _super.prototype.post.call(this, endpoint, { VendorId: item.vendorId })];
                    case 2:
                        response = _a.sent();
                        responseMessage = response.data;
                        if (response.status === 200 && responseMessage.success) {
                            return [2 /*return*/, responseMessage];
                        }
                        else {
                            throw new Error('Unable to check if vendor has contracts associated');
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_9 = _a.sent();
                        console.error("Unable to check if vendor has contracts associated");
                        console.error(error_9);
                        throw error_9;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ContractManagementService.prototype.warnDeleteItemSupplier = function (item) {
        return __awaiter(this, void 0, Promise, function () {
            var endpoint, response, responseMessage, error_10;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        endpoint = '/searchcontractrefany';
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, _super.prototype.post.call(this, endpoint, { SupplierId: item.supplierId })];
                    case 2:
                        response = _a.sent();
                        responseMessage = response.data;
                        if (response.status === 200 && responseMessage.success) {
                            return [2 /*return*/, responseMessage];
                        }
                        else {
                            throw new Error('Unable to check if supplier has contracts associated');
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_10 = _a.sent();
                        console.error("Unable to check if supplier has contracts associated");
                        console.error(error_10);
                        throw error_10;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ContractManagementService = __decorate([
        injectable(),
        __metadata("design:paramtypes", [])
    ], ContractManagementService);
    return ContractManagementService;
}(BaseManagementService));
export { ContractManagementService };
